export const PATH_CHILD_APPLICATION_ROOT = '/child' ;